// src/components/Sidebar.js
// Updated: 11/02/2025 04:50 PM EDT
// --- THIS IS THE FULL, UPDATED FILE ---

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  FileText,
  Vote,
  Award,
  Users,
  Settings,
  Shield, // <-- 1. IMPORT SHIELD ICON
  FileClock, // <-- IMPORT NEW ICON
} from 'lucide-react';

// Reusable navigation link component
const NavLink = ({ to, icon: Icon, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to || (to === '/admin/super/users' && location.pathname.startsWith('/admin/super'));

  return (
    <Link
      to={to}
      className={`
        flex items-center px-4 py-3 text-lg font-medium
        ${
          isActive
            ? 'bg-blue-700 text-white'
            : 'text-gray-300 hover:bg-blue-900 hover:text-white'
        }
        rounded-md transition-colors duration-150
      `}
    >
      <Icon className="mr-3 h-6 w-6" />
      {children}
    </Link>
  );
};

export default function Sidebar() {
  const { userData } = useAuth(); // Get user data to check role

  return (
    <div className="flex h-screen w-64 flex-col bg-blue-800 text-white shadow-lg print-hide">
      <div className="flex h-20 items-center justify-center border-b border-blue-900">
        <h1 className="text-3xl font-bold text-white">BoardVote</h1>
      </div>
      <nav className="flex-1 space-y-2 p-4">
        <NavLink to="/dashboard" icon={LayoutDashboard}>
          Dashboard
        </NavLink>
        <NavLink to="/documents" icon={FileText}>
          Documents
        </NavLink>
        <NavLink to="/voting" icon={Vote}>
          Voting
        </NavLink>
        <NavLink to="/scoring" icon={Award}>
          Scoring
        </NavLink>
        
        {/* Show Admin links only if user's role is 'admin' */}
        {userData && userData.role === 'admin' && (
          <>
            <div className="pt-4">
              <span className="px-4 text-xs font-semibold uppercase text-gray-400">
                Admin
              </span>
            </div>
            <NavLink to="/admin/users" icon={Users}>
              Manage Users
            </NavLink>
            <NavLink to="/admin/settings" icon={Settings}>
              Settings
            </NavLink>
            {/* --- ADD NEW AUDIT LOG LINK --- */}
            <NavLink to="/admin/audit-log" icon={FileClock}>
              Audit Log
            </NavLink>
            {/* --- END NEW LINK --- */}
          </>
        )}

        {/* --- 2. ADD SUPER ADMIN SECTION --- */}
        {/* Show Super Admin links only if user's super_admin flag is true */}
        {userData && userData.super_admin === true && (
          <>
            <div className="pt-4">
              <span className="px-4 text-xs font-semibold uppercase text-purple-300">
                Super Admin
              </span>
            </div>
            <NavLink to="/admin/super/users" icon={Shield}>
              Master User List
            </NavLink>
          </>
        )}
        {/* --- END OF NEW SECTION --- */}

      </nav>
    </div>
  );
}